var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCircle1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#3CDD9F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 26.5,
    fill: "#3CDD9F",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.275 31.18l-3.458 3.198-1.82-2.158 5.564-4.628h2.834V46h-3.12V31.18z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzUiIGhlaWdodD0iNzUiIHZpZXdCb3g9IjAgMCA3NSA3NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzcuNSIgY3k9IjM3LjUiIHI9IjM3LjUiIGZpbGw9IiMzQ0REOUYiLz4KPGNpcmNsZSBjeD0iMzcuNSIgY3k9IjM3LjUiIHI9IjI2LjUiIGZpbGw9IiMzQ0REOUYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMzYuMjc0NiAzMS4xOEwzMi44MTY2IDM0LjM3OEwzMC45OTY2IDMyLjIyTDM2LjU2MDYgMjcuNTkySDM5LjM5NDZWNDZIMzYuMjc0NlYzMS4xOFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgGreenCircle1 as ReactComponent };